$(document).ready(function () {

    loadDgas();

    $('.tab-dossier .dossier-property-note').on('change', function () {
        prepareRequest($(this), $(this).closest('tr').data('property-id'), 'save-note', {
            note: this.value,
        });
    });

    $('.tab-dossier .property-completed').on('change', function () {
        $(this).closest('tr').css("background-color", "#70db8c");

        if (this.value != '') {
            $(this).closest('tr').css("background-color", "#70db8c");
        } else {
            $(this).closest('tr').css("background-color", "#ffffff");
        }

        prepareRequest($(this), $(this).closest('tr').data('property-id'), 'save-completed', {
            completed_at: this.value,
        });
    });

    $('.tab-dossier .property-value').on('change', function () {
        prepareRequest($(this), $(this).closest('tr').data('property-id'), 'save-value', {
            value: this.value,
        });

        // When the value is set to n/a, set the completed date to today, if set to empty, set the completed date to empty
        if (this.value === 'n/a' || this.value === 0 || this.value === '0') {
            let completedInput = $(this).closest('tr').find('.property-completed');
            completedInput.val(new Date().toISOString().slice(0, 10));
            completedInput.change();
        } else if (this.value === '' || this.value === null) {
            let completedInput = $(this).closest('tr').find('.property-completed');
            completedInput.val('');
            completedInput.change();
        }
    });

    $('.tab-dossier .property-second-value').on('change', function () {
        prepareRequest($(this), $(this).closest('tr').data('property-id'), 'save-second-value', {
            second_value: this.value,
        });
    });

    // Update the dossier email identifier
    $('input[name=email_identifier]').on('change', function () {
        const dossierId = $('#dossier-table').data('dossier-id');
        doRequest('/api/dossier/' + dossierId + '/update-emails', {
            email_identifier: this.value,
        }, $(this))
    });

    // Update the dossier email addresses
    $('input[name=dossier_email_addresses]').on('change', function () {
        const dossierId = $('#dossier-table').data('dossier-id');
        doRequest('/api/dossier/' + dossierId + '/update-emails', {
            dossier_email_addresses: this.value,
        }, $(this))
    });

    function prepareRequest(inputElement, propertyId, fieldType, data) {
        const dossier = $('#dossier-table').data('dossier-id');
        const url = '/api/dossier/' + dossier + '/properties/' + propertyId + '/update-field/' + fieldType;
        doRequest(url, data, inputElement);
    }

    function doRequest(url, data, inputElement) {
        $.post(url, data).done(function (data) {
            // Get inputElement parent and add div with error message
            if (data?.success === true) {
                inputElement.parent().find('.invalid-feedback').remove();
                inputElement.removeClass('is-invalid');
            } else {
                inputElement.parent().append('<div class="invalid-feedback">' + data.message + '</div>');
                inputElement.addClass('is-invalid');
            }
        }).fail(function (data) {
            // Parse errors to single string
            let errors = '';
            $.each(data?.responseJSON?.errors, function (key, value) {
                errors += value + ' ';
            });
            inputElement.parent().append('<div class="invalid-feedback">' + errors + '</div>');
            inputElement.addClass('is-invalid');
        });
    }

    $("select[name='legal_type_id']").on('change', function () {
        setLegalSubTypeSelection(this.value);
    });
    let legal_type_id = $("select[name='legal_type_id'] option:selected").val();

    setLegalSubTypeSelection(legal_type_id);

    function setLegalSubTypeSelection(legal_type_id) {
        if (legal_type_id == 1) {
            $("select[name='legal_sub_type_id']").show();
            $("select[name='legal_sub_type_id']").closest( "th" ).find("small").show();
            $("select[name='legal_sub_type_id']").prop('disabled', false);

        } else {
            $("select[name='legal_sub_type_id']").hide();
            $("select[name='legal_sub_type_id']").closest( "th" ).find("small").hide();
            $("select[name='legal_sub_type_id']").prop('disabled', true);
        }
    }

    function loadDgas() {
        for (let i=2;i<=4;i++) {
            if ($('input[name=dga_'+i+']').val() === '') {
                $('input[name=dga_'+i+']').closest( "tr" ).hide();
            } else {
                showDga($(this).data(i));
            }
        }

        for (let i=1;i<=3;i++) {
            let next = i+1;
            if ($('input[name=dga_'+next+']').val() !== '') {
                $('input[name=dga_'+i+']').closest("tr").find('.button-add-dga').hide();
            }
        }
    }

    $(".button-add-dga").on('click', function () {
        $(this).hide();
        showDga($(this).data('dga-number'));
    });

    function showDga(number) {
        $('input[name=dga_'+number+']').closest( "tr" ).show();
    }

    $('.dossier-other-info').on('change', function () {
        var dossierId = $(this).data('dossier-id');

        var url = '/admin/dossiers/'+dossierId+'/save-other-information'
        $.post(url, {
            info: this.value,
        }).done(function (data) {

        });
    });
});
